export default {
    treeMapChart: () => import('./charts/treeMapChart'),
    heatmapChart: () => import("./charts/heatmapChart"),
    heatmapChartfor2dim: () => import("./charts/heatmapChartFor2dim"),

    horizontalbarColorChart: () => import("./charts/horizontalbarColorChart"),

    horizontalbarChart: () => import("./charts/horizontalbarChart"),
    stackedBarChart: () => import("./charts/stackedBarChart"),
    stackedBarSChart: () => import("./charts/stackedBarSChart"),
    waterfallChart: () => import("./charts/waterfallChart"),
    sourceTreemap: () => import("./charts/sourceTreemap"),
    sourceTreemapwithSingleDimension: () => import("./charts/sourceTreemapwithSingleDimension"),
    boxplotChart: () => import("./charts/boxplotChart"),
    cumBarChart: () => import("./charts/cumBarChart"),
    stackedGroupedBarChart: () => import("./charts/stackedGroupedBarChart"),
    bulletChart: () => import("./charts/bulletChart"),
    treeheatmapChart: () => import("./charts/treeheatmapChart"),
    mmlChart: () => import("./charts/mmlChart"),
    mmlChartWithMultipleAxis: () => import("./charts/mmlChartWithMultipleAxis"),
    bubbleChart: () => import("./charts/bubbleChart"),
    bubbleChart3M: () => import("./charts/bubbleChart3M"),
    pcmscatterplotChart: () => import("./charts/pcmscatterplotChart"),
    mspcChart: () => import("./charts/mspcChart"),
    d3PieChart: () => import("./charts/d3PieChart"),
    multiplePieChart_2: () => import("./charts/multiplePieChart_2"),
    multiplePieChart: () => import("./charts/multiplePieChart"),
    multiplePieChartwithLabels: () => import("./charts/multiplePieChartwithLabels"),
    d3PieChartwithSingleColor: () => import("./charts/d3PieChartwithSingleColor"),
    collapsibleChart: () => import("./charts/collapsibleChart"),
    dendogramChart: () => import("./charts/dendogramChart"),
    dendogramChart_V2: () => import("./charts/dendogramChart_V2"),
    dendogramListChart: () => import("./charts/dendogramListChart"),
    histogramChart: () => import("./charts/histogramChart"),
    multiLineChart: () => import("./charts/multiLineChart"),
    multiLineChartXDim: () => import("./charts/multiLineChartXDim"),
    multiLineChartdualaxeswithbar: () => import("./charts/multiLineChartdualaxeswithbar"),
    correlogramChart: () => import("./charts/correlogramChart"),
    hierarchialBarChart: () => import("./charts/hierarchialBarChart"),
    groupBarChart: () => import("./charts/groupBarChart"),
    groupBarChartwithfixedcolors: () => import("./charts/groupBarChartwithfixedcolors"),
    simpleBarChartwithfixedcolors: () => import("./charts/simpleBarChartwithfixedcolors"),
    groupedBarChart: () => import("./charts/groupedBarChart"),
    simpleBarChart: () => import("./charts/simpleBarChart"),
    simpleBarChartWithLine: () => import("./charts/simpleBarChartWithLine"),
    simpleBarChartFixedBar: () => import("./charts/simpleBarChartFixedBar"),
    cooccurencesChart: () => import("./charts/cooccurencesChart"),
    cooccurencesScChart: () => import("./charts/cooccurencesScChart"),
    cooccurencesSampleChart: () => import("./charts/cooccurencesSampleChart"),
    radialtree: () => import("./charts/radialtree"),
    miserablesChart: () => import("./charts/miserablesChart"),
    miserablesEChart: () => import("./charts/miserablesEChart"),
    forceDirectedGraph2M: () => import("./charts/forceDirectedGraph2M"),
    circlepackingChart: () => import("./charts/circlepackingChart"),
    densityChart: () => import("./charts/densityChart"),
    marimekkoChart: () => import("./charts/marimekkoChart"),
    horizontalBoxplotChart: () => import("./charts/horizontalBoxplotChart"),
    mpcbarChart: () => import("./charts/mpcbarChart"),
    multibarChart: () => import("./charts/multibarChart"),
    heatmapChartCompare: () => import("./charts/heatmapChartCompare"),
    dotplotChart: () => import("./charts/dotplotChart"),
    timeseriesChart: () => import("./charts/timeseriesChart"),
    crossfilterChart: () => import("./charts/crossfilterChart"),
    crossfilterDCChart: () => import("./charts/crossfilterDCChart"),
    metricGraphicsUpdating_Metrics: () => import("./charts/metricGraphicsUpdating_Metrics"),
    parallelChart: () => import("./charts/parallelChart"),
    multipleLineChart: () => import("./charts/multipleLineChart"),
    multiLineRegressionChart: () => import("./charts/multiLineRegressionChart"),
    multiLinewith1plot: () => import("./charts/multiLinewith1plot"),
    multiline2plotsdim: () => import("./charts/multiline2plotsdim"),
    multiLineChartdualaxes: () => import("./charts/multiLineChartdualaxes"),
    multiLineChartdualaxesXDim: () => import("./charts/multiLineChartdualaxesXDim"),
    multiLinewith2plots: () => import("./charts/multiLinewith2plots"),
    forceLayout: () => import("./charts/forceLayout"),
    forceDirected: () => import("./charts/forceDirected"),
    forceDirectedN: () => import("./charts/forceDirectedN"),
    forceDirectedNWithoutMeat: () => import("./charts/forceDirectedNWithoutMeat"),
    epidemicsbarChart: () => import("./charts/epidemicsbarChart"),
    beeswarmChart: () => import("./charts/beeswarmChart"),
    beeswarmChartCompare: () => import("./charts/beeswarmChartCompare"),
    tableBarChart: () => import("./charts/tableBarChart"),
    tableWithBarChart: () => import("./charts/tableWithBarChart"),
    tableWithBarLineChart: () => import("./charts/tableWithBarLineChart"),
    BankMapchart: () => import("./charts/BankMapchart"),
    DuroMapchart: () => import("./charts/DuroMapchart"),
    Mapchart: () => import("./charts/Mapchart"),
    paretoChartDim: () => import("./charts/paretoChartDim"),
    paretoChartRevenue: () => import("./charts/paretoChartRevenue"),
    sankeyChart: () => import("./charts/sankeyChart"),
    sankeyChart_v3: () => import("./charts/sankeyChart_v3"),
    torrnadoChart: () => import("./charts/torrnadoChart"),
    hgbChart: () => import("./charts/hgbChart"),
    WMapchart: () => import("./charts/WMapchart"),
    contour2DMap: () => import("./charts/contour2DMap"),
    contourMapchart: () => import("./charts/contourMapchart"),
    newSankeyChart: () => import("./charts/newSankeyChart"),
    smallMultiplelineChart: () => import("./charts/smallMultiplelineChart"),
    d3FunnelChart: () => import("./charts/d3FunnelChart"),
    stackedVerticalBarChart: () => import("./charts/stackedVerticalBarChart"),
    stackedHorizontalBarChart: () => import("./charts/stackedHorizontalBarChart"),
    heatmapChartKA: () => import("./charts/heatmapChartKA"),
    scatterPllot: () => import("./charts/scatterPllot"),
    numberDisplayChart: () => import("./charts/numberDisplayChart"),
    multilineChart2:()=>import("./charts/multiLineChart2"),
    lollipopChart:()=>import("./charts/lollipopChart"),
    BarChartSample_1:()=>import("./charts/BarChartSample_1"),
    linearRegressionChart: () => import("./charts/linearRegressionChart"),
    barChart: () => import("./charts/barChart"),
    stachedBarChartKA: () => import("./charts/stachedBarChartKA"),
    speedoMeter: () => import("./charts/speedoMeter"),
    correlationOrdinal: () => import("./charts/correlationOrdinal"),
    waterfallChartKA: () => import("./charts/waterfallChartKA"),
    horizontalbarChartKA: () => import("./charts/horizontalbarChartKA"),
    mmlChartKA: () => import("./charts/mmlChartKA"),
    trellisChart: () => import("./charts/trellisChart"),
    mmlChartWith2dim: () => import("./charts/mmlChartWith2dim"),
    multiLineChartV_1: () => import("./charts/multiLineChartV_1"),
    multibarChart_V02: () => import("./charts/multibarChart_V02"),
    mmlChart_dynamic_Yaxis: () => import("./charts/mmlChart_dynamic_Yaxis"),
    circlepackingcategoryChart:()=>import("./charts/circlepackingcategoryChart"),
    waterfallWithhorizontalscroll:()=>import("./charts/waterfallWithhorizontalscroll"),
    EtlJobChart:()=>import("./charts/EtlJobChart"),
    EtlGanttChart:()=>import("./charts/EtlGanttChart")

}